export default __webpack_public_path__ + "static/media/delete.eb3564f4.svg";